import { useEffect, useState } from 'react';

export const useScreenSize = () => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const isSmall = screenSize.width < 640;
  const isMedium = screenSize.width >= 640 && screenSize.width < 768;
  const isLarge = screenSize.width >= 768 && screenSize.width < 1024;
  const isXL = screenSize.width >= 1024 && screenSize.width < 1280;
  const is2XL = screenSize.width >= 1280;

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    // Fix the error on mobile devices
    // this was preventing the keyboard from showing up
    // https://github.com/facebook/react/issues/14063#issuecomment-435305942
    if (isLarge || isXL || is2XL) {
      window.addEventListener('resize', handleResize);
    }

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isSmall,
    isMedium,
    isLarge,
    isXL,
    is2XL,
    size: screenSize,
  };
};
